// extracted by mini-css-extract-plugin
export var defaultHero = "hero-module--defaultHero--5Ea51";